/**
 * Sekmeler arası kilit.
 *
 * Jeton yenilemesi sekme içinde zaten teke düşürülüyordu, ama o koruma sekme
 * BAŞINA: `refreshInFlight` bir modül değişkeni ve her sekmenin kendi kopyası
 * var. Yenileme jetonu ise tarayıcı geneli bir httpOnly çerez. İki sekme aynı
 * anda yenilerse ikisi de AYNI çerezi okur; sunucu ikincisini tüketilmiş bir
 * jetonun tekrar sunulması olarak görür, bunu hırsızlık sayar ve o cihazın
 * bütün oturum ailesini iptal eder. Kullanıcı, hiçbir şey yapmadan atılır.
 *
 * Üretimde ölçüldü: bir hesapta 15 `reuse_detected`, sonuncusu 2026-08-13
 * 11:00. Bildiren tarayıcısını sildi ve telefondan giriş yaptığı için
 * atıldığını sandı (DST-00032) — ikisi de değildi.
 *
 * Web Locks tam bu iş için var: aynı origin'deki bütün sekmeler tek bir kilit
 * kuyruğu paylaşır ve sekme çökerse ya da kapanırsa kilit KENDİLİĞİNDEN
 * bırakılır. Elle kurulan bir kilitte (localStorage + zaman damgası) o son
 * cümle yoktur: çöken bir sekmenin kilidi kalır ve herkesi zaman aşımı süresi
 * boyunca dışarıda tutar — yani oturumu düşürmeyi bırakıp oturum açmayı
 * engellersiniz.
 *
 * `navigator.locks` yoksa iş doğrudan koşuyor. O zaman bugünkü davranışa,
 * yani sekme içi tek uçuşa geri düşülür — daha kötü değil, sadece daha az iyi.
 */
export interface KilitApisi {
  request<T>(name: string, fn: () => Promise<T>): Promise<T>;
}

/**
 * `is` işini, aynı `ad` ile çağıran bütün sekmelere karşı sıraya sokar.
 *
 * Kilit API'si parametre, çünkü ölçülebilmesinin tek yolu bu: `navigator.locks`
 * gerçek bir tarayıcı gerektirir ve kilidin işe yarayıp yaramadığı ancak iki
 * eşzamanlı çağrının ÇAKIŞMADIĞI görülerek anlaşılır.
 */
export async function sirayaSok<T>(
  ad: string,
  is: () => Promise<T>,
  kilitler: KilitApisi | undefined = (globalThis as { navigator?: { locks?: KilitApisi } })
    .navigator?.locks,
): Promise<T> {
  if (!kilitler?.request) return is();

  /**
   * İşin BAŞLAYIP başlamadığı ayrı tutuluyor, ve bu şart.
   *
   * Kilit alınamazsa iş yine de yapılmalı: yenilemeyi hiç denememek kullanıcıyı
   * kesin olarak dışarıda bırakır, çakışma ise yalnız bir ihtimaldir. Ama işin
   * KENDİSİ düştüyse tekrar koşturmak, yenilemeyi ikinci kez yapmak demektir —
   * yani bu dosyanın engellemek için var olduğu şeyin ta kendisi. İkisi de
   * `catch`'e aynı kapıdan girdiği için ayırt edilmeleri gerekiyor.
   */
  let basladi = false;
  const sarmal = () => {
    basladi = true;
    return is();
  };

  try {
    return await kilitler.request(ad, sarmal);
  } catch (hata) {
    if (basladi) throw hata;
    return is();
  }
}
